// extracted by mini-css-extract-plugin
module.exports = {"switch":"style_switch__2mEo5"};